exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sort-options-panel{width:80%;margin:48px auto 0}#sort-options-panel>span{font-size:16px;font-weight:700;color:#00adb5}#sort-options>button{background-color:hsla(0,0%,50%,.1);color:hsla(0,0%,50%,.6)}#sort-options>button:focus,#sort-options>button:hover{background-color:hsla(0,0%,50%,.3);color:#ffbf00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d85ef48","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SortOptions.vue
// module id = 523
// module chunks = 0